// The leads screens (docs/customer-module/leads/00-Overview.md): one list
// page with its own create/edit and convert dialogs. 'leadsHome' is kept
// stable: the sidebar links to it by name (src/components/Common/SideBar.vue).
const leadsRoutes = [
    {
        name: "leadsHome",
        path: "leads",
        component: () => import("./LeadList.vue"),
        meta: {
            auth: true,
            title: "Leads",
            breadcrumb: "Leads",
            permission: ["view leads"],
        },
    },
];

export default leadsRoutes;
